module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"heading":{"video":"Video","oss":"Open Source","pr":"Awards & News"},"message":{"lead1":"Preparing for Disasters","lead2":"Plan ahead your actions & get notified in disasters"}},"ja":{"heading":{"video":"ビデオ","oss":"オープンソース","pr":"受賞・メディア"},"message":{"lead1":"災害に備えよう","lead2":"行動フローを事前に作成・発生時に支援"}}}')
  delete Component.options._Ctor
}
